"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItem = void 0;
const react_1 = __importDefault(require("react"));
const Target_1 = require("../../components/Target");
const foundations_1 = require("../../foundations");
const Icon_1 = require("../../foundations/IconV2/Icon");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const useExpandContent_1 = require("../../hooks/useExpandContent");
const useId_1 = require("../../hooks/useId");
const useWarning_1 = require("../../hooks/useWarning");
const Accordion_1 = require("./Accordion");
const AccordionItem = (props) => {
    const { expandContent } = (0, useExpandContent_1.useExpandContent)();
    const { warn } = (0, useWarning_1.useWarning)();
    const { body, children, title, defaultOpen } = props;
    const { toggleItem, getIsExpanded } = react_1.default.useContext(Accordion_1.AccordionContext);
    const itemId = (0, useId_1.useId)();
    if (title === null) {
        warn("The `title` prop of a AccordionItem component is null. Please pass either a string or ReactNode.");
    }
    const isFirstRender = react_1.default.useRef(true);
    if (isFirstRender.current && defaultOpen) {
        toggleItem(itemId);
        isFirstRender.current = false;
    }
    const isOpen = expandContent || getIsExpanded(itemId) || false;
    const contentRef = react_1.default.useRef(null);
    const targetSxProps = {
        fontWeight: "font-weight-medium",
        color: "text-default",
        px: "spacing-5",
        py: "spacing-4",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "stroke-neutral-tertiary",
        marginTop: "-1px",
        width: "100%",
        fontSize: "font-size-5",
        lineHeight: "leading-2"
    };
    if (contentRef.current) {
        if (expandContent) {
            contentRef.current.style.removeProperty("max-height");
        }
        else if (isOpen) {
            contentRef.current.style.maxHeight =
                contentRef.current.scrollHeight + "px";
        }
        else {
            contentRef.current.style.maxHeight = "0";
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Target_1.Target, { sx: Object.assign(Object.assign({}, targetSxProps), { cursor: children ? "pointer" : "default" }), onClick: () => toggleItem(itemId), "aria-expanded": isOpen, "aria-controls": `itemContent-${itemId}` },
            react_1.default.createElement(foundations_1.Box, { sx: {
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "space-between"
                } },
                title,
                (children || body) && (react_1.default.createElement(Icon_1.IconV2, { size: "sm", icon: isOpen ? "caret-up" : "caret-down", sx: {
                        color: "button-onSurface-subtle-enabled",
                        minWidth: "spacing-6",
                        paddingLeft: "spacing-2"
                    } })))),
        react_1.default.createElement(foundations_1.Box, { ref: contentRef, sx: {
                overflow: "hidden",
                transition: expandContent
                    ? null
                    : () => "max-height 300ms cubic-bezier(0.4, 0, 0, 1)",
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: "stroke-neutral-tertiary",
                maxHeight: expandContent || defaultOpen ? undefined : 0
            }, id: `itemContent-${itemId}` },
            body && (react_1.default.createElement(foundations_1.Box, { sx: {
                    px: "spacing-5",
                    pb: "spacing-4"
                } },
                react_1.default.createElement(TextV2_1.TextV2, { variant: "body-1-regular" }, body))),
            children && (react_1.default.createElement(foundations_1.Box, { sx: {
                    px: "spacing-5",
                    pb: "spacing-4"
                } }, children)))));
};
exports.AccordionItem = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map